import React from 'react';
import { observer } from 'mobx-react-lite';
import { CarouselMainState } from './CarouselMainState.state';
import { TabItem, TabsWrapper } from 'src/domains/layouts/shared/tabs/Tabs.style';

interface PropsTypes {
    carouselMainState: CarouselMainState;
}

export const PromoCarouselNav = observer(({carouselMainState}: PropsTypes) => {
    return (
        <TabsWrapper>
            <TabItem
                isActive={carouselMainState.carouselMode === 'homepage'}
                onClick={(): void => carouselMainState.onChangeCarouselMode('homepage')}
            >
                Homepage
            </TabItem>

            <TabItem
                isActive={carouselMainState.carouselMode === 'virtuals'}
                onClick={(): void => carouselMainState.onChangeCarouselMode('virtuals')}
            >
                Virtuals
            </TabItem>

            <TabItem
                isActive={carouselMainState.carouselMode === 'casino'}
                onClick={(): void => carouselMainState.onChangeCarouselMode('casino')}
            >
                    Casino
            </TabItem>

            <TabItem
                isActive={carouselMainState.carouselMode === 'live-casino'}
                onClick={(): void => carouselMainState.onChangeCarouselMode('live-casino')}
            >
                Live Casino
            </TabItem>
        </TabsWrapper>
    );
});
